import React, { useMemo, useRef } from "react";
import ReactECharts from "echarts-for-react";

const NewHeatMapChart = ({
  title = "",
  rows = [],
  cols = [],
  data = [],
  colors = [],
  height = 400,
  maxValue = null,
  showLabels = true,
}) => {
  const chartRef = useRef(null);

  // Normalize matrix safely
  const safeMatrix = useMemo(() => {
    if (!rows.length || !cols.length) return [];
    return rows.map((_, r) => cols.map((_, c) => Number(data?.[r]?.[c] ?? 0)));
  }, [rows, cols, data]);

  const heatmapData = useMemo(() => {
    return safeMatrix.flatMap((row, y) => row.map((value, x) => [x, y, value]));
  }, [safeMatrix]);

  const computedMax = useMemo(() => {
    if (maxValue) return maxValue;
    const flat = safeMatrix.flat();
    return Math.max(1, ...flat);
  }, [safeMatrix, maxValue]);

  const option = {
    title: { text: title, left: "center" },

    tooltip: {
      formatter: (p) =>
        `${rows[p.data[1]]}<br>${cols[p.data[0]]}: <b>${p.data[2]}</b>`,
    },

    grid: { top: 60, bottom: 60 },

    xAxis: { type: "category", data: cols, splitArea: { show: true } },
    yAxis: { type: "category", data: rows, splitArea: { show: true } },

    visualMap: {
      min: 0,
      max: computedMax,
      orient: "horizontal",
      left: "center",
      bottom: 10,
      inRange: {
        color: colors.length
          ? colors
          : ["#fff6d5", "#ffd57a", "#fdbe58", "#ff9544", "#f32629"],
      },
    },

    series: [
      {
        type: "heatmap",
        data: heatmapData,
        label: { show: showLabels },
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowColor: "rgba(0,0,0,0.4)",
          },
        },
      },
    ],
  };

  return (
    <ReactECharts
      ref={chartRef}
      option={option}
      style={{ height, width: "100%" }}
    />
  );
};

export default NewHeatMapChart;
